// Carregamento sob demanda do proj4 (~240 kB + mgrs), para não pesar no
// bundle de arranque do viewer: só quem usa mapa/geo é que o paga.
//
// Estado global: o proj4 mantém um registo interno de definições
// (proj4.defs). Hoje o viewer NÃO regista defs em módulo: o crsDefs.ts
// resolve o EPSG para uma STRING de definição que é passada em cada
// chamada, proj4(def, 'WGS84', ...), por isso não há registos a perder.
// Ainda assim, este helper devolve sempre a MESMA instância (cache do
// módulo + cache da promessa), de modo que qualquer defs() futuro fique
// visível para todos os consumidores. O import estático do MapPanel
// resolve para esta mesma instância: o registo de módulos ES garante uma
// só cópia, o dynamic import não cria uma segunda.

// O proj4 declara `export = proj4`, por isso o tipo do namespace já é a
// própria função.
type Proj4 = typeof import('proj4')

let cached: Proj4 | null = null
let pending: Promise<Proj4> | null = null

/** Devolve a instância do proj4, carregando-a à primeira chamada. */
export function loadProj4(): Promise<Proj4> {
  if (cached) return Promise.resolve(cached)
  if (!pending) {
    pending = import('proj4').then((m) => {
      // O proj4 é CJS: conforme o interop do bundler, a função vem em
      // `default` ou é já o próprio namespace.
      const mod = m as Proj4 & { default?: Proj4 }
      const lib = mod.default ?? mod
      cached = lib
      return lib
    })
  }
  return pending
}
